<template>
  <div class="recommend" style="padding-left: var(--shrink);">
    <swiperx :swiperOptions="swiperOptions">
      <template #slides>
        <swiper-slide
          v-for="(item, index) in menuList"
          :key="index + 'banner'"
          :style="{ display: item.id == 0 || item.is_index == 0 ? 'none' : 'flex' }"
        >
          <router-link
            class="item"
            :to="`/recommend?id=${item.id}&title=${item.cate_name}`"
          >
            <p class="title" style="font-weight: bold;">{{ item.cate_name }}</p>
            <p class="des">{{ item.content }}</p>
            <p class="img">
              <img :src="item.pic" />
            </p>
          </router-link>
          <!-- <img :src="item.imagePath" alt="" width="100%" /> -->
        </swiper-slide>
      </template>
    </swiperx>
  </div>
</template>

<script>
import swiperx from "@/components/swiperx.vue";
import { swiperSlide } from "vue-awesome-swiper";
export default {
  name: "recommendCom",
  components: {
    swiperx,
    swiperSlide,
  },
  props: {
    menuList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 0,
        freeMode: true,
      },
    };
  },
};
</script>
